export const environment = {
  production: true,
  apiURL: 'https://declarations.federale.be/sofiaformsAPI/',
  name: 'Prod',
  esbuser: 'BIZTALKPRDUSERESB',
  myFederale: 'https://my.federale.be//SecurePages/Home.aspx?lang=',
  wwwFederale: 'https://federale.be/',
  FilePath: "\\\\clfs\\pdf-intranet$\\PRD\\OnlineDeclaration\\",
  FilePathDocumentum: '\\\\clfs\\TransIT-prd\\FileToMove\\Documentum\\IntegrationServer\\',
  sofiaMailURL : 'https://declarations.federale.be/#'
};
